import { addMonetaryValues } from '../../../../utils/monetary-value-utils';
import { getOrderItems } from './get-order-items';
export const getOrderItemsTotalPrice = () => addMonetaryValues(...getOrderItems().map(item => item.price));
